import { Component, Input } from '@angular/core';
import { ActiveUser } from 'app/shared/services/user/active-user.model';

@Component({
  selector: 'tog-user-avatar',
  templateUrl: 'user-avatar.template.html',
  styleUrls: ['user-avatar.scss']
})
export class UserAvatarComponent {
  @Input() size: number = 40;
  @Input() user: ActiveUser;
  @Input() app: any;

  get logo() {
    let logo = '';
    if (this.app) {
      logo = this.app.logo;
    } else if (this.user.applications && this.user.applications.length) {
      logo = this.user.applications[0].logo;
    }
    return 'url(' + (logo || '/assets/avatar-placeholder.png') + ')';
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/components/user-avatar/user-avatar.component.ts